<!-- input-meters.component.html -->

<!-- Logout Button (Top Right) -->
<div class="logout-button-container">
  <button mat-button class="logout-button" (click)="logoutKeycloak()">
    <mat-icon>exit_to_app</mat-icon> Αποσύνδεση
  </button>
</div>

<!-- Loading indicator while checking for previous applications -->
<div *ngIf="loadingProgress" class="loading-overlay">
  <div class="loading-spinner"></div>
  <p>Παρακαλώ περιμένετε...</p>
</div>

<!-- New Immediate Recall Prompt -->
<div *ngIf="showImmediateRecallPrompt && previousApplication" class="immediate-recall-overlay">
  <div class="immediate-recall-container">
    <div class="immediate-recall-content">
      <h3>Προηγούμενη Αίτηση</h3>
      
      <p>Υπάρχει ήδη αίτηση με το ΑΦΜ <strong>{{ previousApplication.vat_number }}</strong> με τα ακόλουθα στοιχεία:</p>
      
      <div class="previous-application-details">
        <div class="detail-row">
          <span class="detail-label">Αριθμός Αίτησης:</span>
          <span class="detail-value">{{ previousApplication.aa_number }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Ημερομηνία:</span>
          <span class="detail-value">{{ formatDate(previousApplication.datetime) }}</span>
        </div>
        
        <!-- Group meter details by subsidy item -->
        <ng-container *ngFor="let subsidy of previousApplication.subsidy; let i = index">
          <div class="meter-group">
            <div class="meter-header">Παροχή {{ i + 1 }}</div>
            <div class="detail-row">
              <span class="detail-label">Αριθμός Παροχής:</span>
              <span class="detail-value">{{ subsidy.meter_id }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Κατάσταση:</span>
              <span class="detail-value" [ngClass]="{'status-success': subsidy.status === 'success', 'status-rejected': subsidy.status === 'rejected', 'status-pending': subsidy.status === 'pending'}">
                {{ subsidy.status === 'success' ? 'Επιτυχής' : (subsidy.status === 'rejected' ? 'Απορριφθείσα' : 'Σε αναμονή') }}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Επιδότηση:</span>
              <span class="detail-value">{{ subsidy.status === 'pending' ? '-' : subsidy.total_subsidy.toFixed(2) + '€' }}</span>
            </div>
          </div>
        </ng-container>
      </div>
      
      <div class="recall-actions">
        <button class="btn-secondary" (click)="closeImmediateRecallPrompt(false)">Διατήρηση & Αποσύνδεση</button>
        <button class="btn-primary" (click)="closeImmediateRecallPrompt(true)">Ανάκληση και Υποβολή νέας</button>
      </div>
    </div>
  </div>
</div>

<div class="terms-container" *ngIf="showTerms">
  <!-- First Terms Popup -->
  <div class="terms-popup animate-card" *ngIf="currentStep === 1">
    <div class="card-header">
      <h2>ΚΕΙΜΕΝΟ ΣΥΝΑΙΝΕΣΗΣ – ΥΠΕΥΘΥΝΩΝ ΔΗΛΩΣΕΩΝ</h2>
    </div>
    <div class="card-body" #firstTermsScroll (scroll)="onTermsScroll($event, 1)">
      <div class="terms-content" style="text-align: justify; line-height: 1.5; padding: 0 5px;" [innerHTML]="firstTermsText">
        <!-- Content will be inserted dynamically -->
      </div>
      
    </div>
    <div class="card-footer">
      <div class="checkbox-section">
        <label class="custom-checkbox">
          <input 
            type="checkbox" 
            [disabled]="!firstTermsScrolled" 
            [(ngModel)]="firstTermsAccepted"
          >
          <span class="checkmark-box"></span>
          <span class="checkbox-text">Συναινώ με τους όρους</span>
        </label>
          <p class="scroll-hint" *ngIf="!firstTermsScrolled"><small>Kύλιση προς τα κάτω</small></p>
      
      </div>
      <div class="button-section">
        <button 
          class="connectivity-button" 
          [disabled]="!firstTermsAccepted" 
          (click)="nextStep()"
        >
          {{'SUBMIT' | translate}}
        </button>
      </div>
    </div>
  </div>

  <!-- Second Terms Popup -->
  <div class="terms-popup animate-card" *ngIf="currentStep === 2">
    <div class="card-header">
      <h2>Όροι Χρήσης και Επεξεργασία</h2>
    </div>
    <div class="card-body" #secondTermsScroll (scroll)="onTermsScroll($event, 2)">
      <div class="terms-content" style="text-align: justify; line-height: 1.5; padding: 0 5px;" [innerHTML]="secondTermsText">
        <!-- Content will be inserted dynamically -->
      </div>
    </div>
    <div class="card-footer">
      <div class="checkbox-section">
        <label class="custom-checkbox">
          <input 
            type="checkbox" 
            [disabled]="!secondTermsScrolled" 
            [(ngModel)]="secondTermsAccepted"
          >
          <span class="checkmark-box"></span>
          <span class="checkbox-text">Συναινώ με τους όρους</span>
        </label>

        <p class="scroll-hint" *ngIf="!secondTermsScrolled"><small>Kύλιση προς τα κάτω</small></p>
      </div>
      <div class="button-section">
        <button 
          class="connectivity-button" 
          [disabled]="!secondTermsAccepted" 
          (click)="completeTerms()"
        >
          {{'SUBMIT' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- DECLARATIONS / CONFIRMATIONS SECTION -->
<div class="terms-popup animate-card" *ngIf="!showTerms && currentStep === 3">
  <div class="card-header">
    <h2>ΔΗΛΩΣΕΙΣ – ΕΠΙΒΕΒΑΙΩΣΕΙΣ</h2>
  </div>

  <div class="card-body">
    <p>Δηλώνω υπεύθυνα ότι η αιτούσα επιχείρηση:</p>

    <div class="checkboxes-container">

      <!-- #1-3 : stay simple checkboxes -->
      <div class="checkbox-item animate-field"
           *ngFor="let item of confirmationItems | slice:0:3; let i = index"
           [style]="{'--index': i}">
        <label class="custom-checkbox">
          <input type="checkbox"
                 [(ngModel)]="item.checked">
          <span class="checkmark-box"></span>
          <span class="checkbox-text">{{ item.text }}</span>
        </label>
      </div>

      <!-- #4 : ΝΑΙ / ΟΧΙ (required) -->
      <div class="checkbox-item animate-field" [style]="{'--index': 3}">
        <span class="checkbox-text d-block mb-2">{{ companyLabel }}</span>

        <div class="yes-no-group">
          <label class="custom-radio me-4">
            <input  type="radio"
                    name="unifiedCompany"
                    value="yes"
                    [(ngModel)]="unifiedCompanySelection"
                    (change)="onUnifiedCompanyChange()">
            <span class="radio-mark"></span> ΝΑΙ
          </label>

          <label class="custom-radio">
            <input  type="radio"
                    name="unifiedCompany"
                    value="no"
                    [(ngModel)]="unifiedCompanySelection"
                    (change)="onUnifiedCompanyChange()">
            <span class="radio-mark"></span> ΟΧΙ
          </label>
        </div>

        <!-- related companies appear only if ΝΑΙ -->
        <ng-container *ngIf="unifiedCompanySelection === 'yes'">
          <div class="related-companies-container">
            <div class="related-company-item"
                  *ngFor="let company of relatedCompanies; let i = index">
              <div class="company-fields">

                <div class="input-field">
                  <label>
                    ΑΦΜ
                    <small style="color: red;" class="error" 
                      *ngIf="company.vat && company.vat.length > 0 && company.vat.length !== 9">
                      9 ψηφία
                    </small>
                    <small style="color: red;" class="error" 
                      *ngIf="company.vat && company.vat.length === 9 && !isValidAFM">
                      Μη έγκυρο ΑΦΜ
                    </small>
                  </label>
                  <input type="text"
                         [(ngModel)]="company.vat"
                         placeholder="ΑΦΜ επιχείρησης"
                         maxlength="9"
                         [class.error]="(company.vat && company.vat.length > 0 && company.vat.length !== 9) || 
                                        (company.vat && company.vat.length === 9 && !isValidAFM)"
                         (keydown)="onKeyDownDigitsOnly($event)"
                         (input)="validateAfmInput($event, company)">
                </div>

                <div class="input-field">
                  <label>Όνομα Επιχείρησης</label>
                  <input  type="text"
                          [(ngModel)]="company.name"
                          placeholder="Όνομα επιχείρησης"
                          (keydown)="onKeyDownLettersOnly($event)"
                          (input)="validateTextInput($event,'name',company)">
                </div>

                <button type="button"
                        class="remove-btn"
                        (click)="removeRelatedCompany(i)"
                        *ngIf="relatedCompanies.length > 1">
                  <span class="remove-icon">✕</span>
                </button>

              </div>
            </div>

            <button type="button"
                    class="add-company-btn"
                    (click)="addRelatedCompany()">
              <span class="add-icon">+</span> Προσθήκη επιχείρησης
            </button>
          </div>
        </ng-container>
      </div>

      <!-- #5 : τελική δήλωση – unlocked only when all above are valid -->
      <div style="margin-top: 15px;" class="checkbox-item animate-field" [style]="{'--index': 4}">
        <label class="custom-checkbox">
          <input  type="checkbox"
                  [(ngModel)]="finalConfirmChecked"
                  [disabled]="!canEnableFinalConfirm()">
          <span class="checkmark-box"></span>
          <span class="checkbox-text">{{ finalConfirmLabel }}</span>
        </label>
        <p class="field-hint" *ngIf="!canEnableFinalConfirm()" ><small>Συμπληρώστε όλα τα πεδία</small></p>
      </div>

    </div> <!-- /checkboxes-container -->
  </div>   <!-- /card-body -->

  <div class="card-footer">
    <div class="button-section">
      <button class="connectivity-button"
              [disabled]="!canSubmit()"
              (click)="submitConfirmations()">
        {{ 'SUBMIT' | translate }}
      </button>
    </div>
  </div>
</div>


<!-- Personal Information Form (new step between declarations and meters) -->
<div class="form-card animate-card" *ngIf="!showTerms && currentStep === 4">
  <div class="card-header">
    <h2>Στοιχεία Επικοινωνίας</h2>
  </div>
  <div class="card-body">
    <p class="form-hint"><small>ΣΥΜΠΛΗΡΩΣΗ ΜΕ ΚΕΦΑΛΑΙΑ</small></p>

    <form [formGroup]="personalInfoForm" (ngSubmit)="submitPersonalInfo()" *ngIf="!isFormSubmitting">
      
      <!-- NAME -->
      <div class="form-row">
        <label for="name">
          {{ 'NAME' | translate }} *
          <small style="color: red;" class="error"
                 *ngIf="personalInfoForm.get('name')?.touched && personalInfoForm.get('name')?.invalid">
            {{ personalInfoForm.get('name')?.errors?.['required']
               ? ('REQUIRED' | translate)
               : personalInfoForm.get('name')?.errors?.['pattern']
                 ? ('ONLY_LETTERS' | translate)
                 : '' }}
          </small>
        </label>
        <div class="input-group">
          <input 
            id="name"
            type="text"
            formControlName="name"
            placeholder="{{ 'NAME' | translate }}"
            (keydown)="onKeyDownLettersOnly($event)"
            (input)="convertToUppercase($event, 'name')"
          >
        </div>
      </div>

      <!-- SURNAME -->
      <div class="form-row">
        <label for="surname">
          {{ 'SURNAME' | translate }} *
          <small style="color: red;" class="error"
                 *ngIf="personalInfoForm.get('surname')?.touched && personalInfoForm.get('surname')?.invalid">
            {{ personalInfoForm.get('surname')?.errors?.['required']
               ? ('REQUIRED' | translate)
               : personalInfoForm.get('surname')?.errors?.['pattern']
                 ? ('ONLY_LETTERS' | translate)
                 : '' }}
          </small>
        </label>
        <div class="input-group">
          <input 
            id="surname"
            type="text"
            formControlName="surname"
            placeholder="{{ 'SURNAME' | translate }}"
            (keydown)="onKeyDownLettersOnly($event)"
            (input)="convertToUppercase($event, 'surname')"
          >
        </div>
      </div>

      <!-- EMAIL -->
      <div class="form-row">
        <label for="email">
          {{ 'EMAIL' | translate }} *
          <small style="color: red;" class="error"
                 *ngIf="personalInfoForm.get('email')?.touched && personalInfoForm.get('email')?.invalid">
            {{ personalInfoForm.get('email')?.errors?.['required']
               ? ('REQUIRED' | translate)
               : personalInfoForm.get('email')?.errors?.['email']
                 ? ('VALID_EMAIL' | translate)
                 : '' }}
          </small>
        </label>
        <div class="input-group">
          <input 
            id="email"
            type="email"
            formControlName="email"
            placeholder="{{ 'EMAIL' | translate }}"
          >
        </div>
      </div>

      <!-- MOBILE NUMBER -->
      <div class="form-row">
        <label for="mobileNumber">
          {{ 'MOBILE_NUMBER' | translate }} *
          <small style="color: red;" class="error"
                 *ngIf="personalInfoForm.get('mobileNumber')?.touched && personalInfoForm.get('mobileNumber')?.invalid">
            {{ personalInfoForm.get('mobileNumber')?.errors?.['required']
               ? ('REQUIRED' | translate)
               : personalInfoForm.get('mobileNumber')?.errors?.['pattern']
                 ? 'Πρέπει να ξεκινάει με 69'
                 : personalInfoForm.get('mobileNumber')?.errors?.['maxlength'] || personalInfoForm.get('mobileNumber')?.errors?.['minLength']
                   ? ('MAX_TEN_DIGITS' | translate)
                   : '' }}
          </small>
        </label>
        <div class="input-group">
          <input 
            id="mobileNumber"
            type="tel"
            formControlName="mobileNumber"
            maxlength="10"
            placeholder="69XXXXXXXX"
            (keydown)="onKeyDownDigitsOnly($event)"
          >
        </div>
      </div>

      <!-- Error message if submission failed -->
      <div class="error-message" *ngIf="formErrorMessage">
        {{ formErrorMessage }}
      </div>
    </form>

    <!-- Loading Spinner -->
    <div class="spinner-container" *ngIf="isFormSubmitting">
      <div class="spinner"></div>
      <p>{{ 'SUBMIT' | translate }}..</p>
    </div>
  </div>

  <div class="card-footer">
    <div class="button-section">
      <button
        class="connectivity-button"
        [disabled]="personalInfoForm.invalid"
        (click)="submitPersonalInfo()"
        *ngIf="!isFormSubmitting"
      >
        {{ 'SUBMIT' | translate }}
      </button>
    </div>
  </div>
</div>


<div *ngIf="!showTerms && currentStep === 5">
  <!-- Floating back button at top-left of viewport -->
  <div class="floating-back-button">
    <button class="logout-button" (click)="goBackToDeclarations()">
      <span class="back-icon">←</span> Πίσω
    </button>
  </div>

  <!-- Meters selection (shown after all confirmations and personal info) -->
  <div class="input-meters-card animate-card" *ngIf="!showTerms && currentStep === 5">
    <div class="card-header">
      <h2>{{ title }}</h2>
      
      <!-- Recall button in top right corner -->
      <!-- <button 
        *ngIf="hasPreviousApplications" 
        class="recall-button" 
        (click)="openRecallDialog()"
      >
        <span class="recall-icon">↺</span> Ανάκληση Προηγούμενης Αίτησης
      </button> -->
    </div>
    
    <div class="card-body">
      <div class="meter-inputs">
        <!-- Error message display - show when there's an error message -->
        <div *ngIf="formErrorMessage" class="error-message-container">
          <div class="error-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <p class="error-state-message">{{ formErrorMessage }}</p>
        </div>

        <!-- Empty state when no meters are available and no error message -->
        <div *ngIf="inputs.length === 0 && !formErrorMessage" class="empty-state">
          <div class="empty-state-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <p class="empty-state-message">Δεν υπάρχουν παροχές.</p>
        </div>

        <!-- Only show this content when there are meters and no error -->
        <ng-container *ngIf="inputs.length > 0 && !formErrorMessage">
          <!-- Select All checkbox -->
          <div class="input-group animate-field" [style]="{'--index': 0}">
            <div class="meter-item select-all-item">
              <div class="checkbox-wrapper">
                <label class="custom-checkbox">
                  <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAllChange()">
                  <span class="checkmark-box"></span>
                </label>
              </div>
              <div class="meter-display">{{ 'SELECT_ALL' | translate }}</div>
            </div>
          </div>
      
          <!-- Individual meter checkboxes with residential meters disabled -->
          <div *ngFor="let input of inputs; let i = index" 
               class="input-group animate-field" 
               [style]="{'--index': i + 1}">
            <div class="meter-item" [class.residential-meter]="input.xrhsh === 'Οικιακή'">
              <div class="checkbox-wrapper">
                <label class="custom-checkbox">
                  <input 
                    type="checkbox" 
                    [(ngModel)]="input.selected" 
                    (change)="onCheckboxChange()"
                    [disabled]="input.xrhsh === 'Οικιακή'"
                  >
                  <span class="checkmark-box"></span>
                </label>
              </div>
              <div class="meter-display">
                <span class="supply-number">{{ input.value }}</span>
                <span *ngIf="input.xrhsh === 'Οικιακή'" class="residential-label"> - Μη Επιλέξιμη</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="card-footer">
      <div class="connectivity-section">
        <button 
          (click)="onSubmit()" 
          class="connectivity-button" 
          [style.display]="inputs.length === 0 ? 'none' : 'block'"
          [disabled]="!isAtLeastOneSelected && inputs.length > 0">
          {{ 'SUBMIT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Recall Dialog -->
<div class="dialog-overlay" *ngIf="showRecallDialog">
  <div class="dialog-container animate-card">
    <div class="dialog-header">
      <h3>Ανάκληση Αίτησης</h3>
    </div>
    <div class="dialog-body">
      <p>Είστε σίγουρος ότι θέλετε να προχωρήσετε σε ανάκληση της προηγούμενης αίτησης σας;</p>
    </div>
    <div class="dialog-footer">
      <button class="secondary-button" (click)="closeRecallDialog()">Όχι</button>
      <button class="primary-button" (click)="sendRecallRequest()">Ναι</button>
    </div>
  </div>
</div>

<!-- Success Dialog -->
<div class="dialog-overlay" *ngIf="showSuccessDialog">
  <div class="dialog-container animate-card">
    <div class="dialog-header">
      <h3>Επιτυχής ανάκληση</h3>
    </div>
    <div class="dialog-body">
      <div class="success-icon">✓</div>
      <p>{{ successMessage }}</p>
    </div>
    <div class="dialog-footer">
      <button class="primary-button" (click)="closeSuccessDialog()">OK</button>
    </div>
  </div>
</div>

<!-- Loading indicator -->
<div class="loading-overlay" *ngIf="loadingProgress">
  <div class="loading-spinner"></div>
  <p>Επεξεργασία Αίτησης..</p>
</div>